import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { UsersService } from '../../_services/users.service';
import { SharedFunctionsService } from '../../_services/sharedFunctions.service';
import { IuserInformation } from '../../_types/userInterfaces.type';
import { UserProfileService } from '../../../_services/user-profile.service';
import { UserProfile } from '../../../_models/user-profile';

declare let $: any;

@Component({

  selector: 'reports-acl',
  templateUrl: './reportsACL.component.html',
  styleUrls: ['./reportsACL.component.css']

})

export class ReportsACLComponent implements OnInit, OnChanges {
  public company: string = "";
  public search: string = "";
  public reportsRoot: reportExe[] = [];
  public reportsOwned: reportExe[] = [];
  public reportsAva: reportExe[] = [];
  public reportActiveChangeCount: number = 0;
  public loading: boolean = false;
  public btnFilterSelected: string = 'all';
  public vReports: number = 0;
  public aReports: number = 0;
  public up: UserProfile
  public dummbyValue: any = new Date();
  public tableName = "All";
  @Input() public user: IuserInformation;
  @Input() public mode: state;
  @Output() hasChangedTrue: EventEmitter<any> = new EventEmitter();
  @Output() hasChangedFalse: EventEmitter<any> = new EventEmitter();
  @Output() public owed: reportExe[];
  public sortArrayObj = {
    reportName: true
  }

  constructor(private UserService: UsersService,
    private SharedFunctions: SharedFunctionsService,
    private ups: UserProfileService) {
    this.ups.userProfile$.subscribe(result => {
      this.up = result
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.mode != "undefined") {
      this.mode = <state>changes.mode.currentValue;
    }
    else if (typeof changes.user != "undefined") {
      this.user = <IuserInformation>changes.user.currentValue;
       this.getReports();
    }
  }

  ngOnInit() {
    if (typeof window != 'undefined') {

      $('[data-toggle="tooltip"]').tooltip()

      this.company = this.up.currentCompany;
      if (typeof this.user != "undefined" && null != this.user) {
        this.getReports();
      }

    }
  }

  orderList(columnName: string) {
    this.SharedFunctions.sortArray(this.reportsAva, columnName, this.sortArrayObj);
    if (this.sortArrayObj[columnName]) {
      this.sortArrayObj[columnName] = false;
    } else {
      this.sortArrayObj[columnName] = true;
    }
    this.dummbyValue = new Date();
  }

  refresh() {
    if (this.mode == 0 || this.mode.toString() == "editMode") {
      this.getReports();
      this.search = "";
      this.btnFilterSelected = "all";
    }
  }

  getReports() {
    if (this.loading == false) { 
    this.loading = true;
    this.aReports = 0
    let testReportsCount: number = 0
    this.UserService.getReportsInCompany(this.company)
      .subscribe(result => {
        this.reportsRoot = <reportExe[]>result;
        this.reportsAva = Object.assign([], this.reportsRoot)
        this.reportsAva.forEach(report => {
          report.reportDescription.trim();
          report.reportDescPopup = report.reportDescription
          report.lockClass = "btn btn-outline-success";
          report.lockIcon = "fas fa-plus"
        })
        testReportsCount = this.reportsAva.length

        this.sortArrayObj.reportName = true;

        this.orderList('reportName');
        if (this.mode == 1 || this.mode.toString() == "createMode") {
          this.loading = false;
        } else {
          this.getOwnedReports();
        }
        this.aReports = testReportsCount
      },
        error => {
          console.log(error);
          this.loading = false;
        });
  }
}

  getOwnedReports() {
    if (null != this.user.username && "" != this.user.username) {
      let reportsNum: number = 0;
    this.UserService.getUserReportACL(this.user.username, this.company)
      .subscribe(result => {
        
        this.reportsOwned = <reportExe[]>result;
        reportsNum = this.reportsOwned.length;
        this.reportsOwned.forEach(report => {
          report.reportDescPopup = report.reportDescription;
        });

        this.aReports = this.aReports - reportsNum;
        
        this.vReports = reportsNum;
        if (this.reportsOwned.length > 0) {
         this.compareReports();
        }
        this.loading = false;
      },
        error => {
          console.log(error);
          this.loading = false;
        });
    }
  }

  compareReports() {
    this.reportsOwned.forEach(owned => {
      let indexAva = this.reportsAva.findIndex(ava =>  ava.reportFilename == owned.reportFilename && ava.reportName == owned.reportName && ava.reportDescription == owned.reportDescription)
      this.reportsAva[indexAva].lockIcon = "fas fa-minus"
      this.reportsAva[indexAva].lockClass = "btn btn-outline-danger"

    })
    this.loading = false;
  }

  buttonFilter(btnName: string) {
    this.search = "";
    this.reportsAva = Object.assign([],this.reportsRoot)
    this.compareReports();
    if (btnName !== "all") {
      if (btnName === "plus") { this.tableName = "Available"}
      else { this.tableName = "Visible"}
      
      let tempList: reportExe[] = [];
      tempList = this.reportsAva.filter(report => report.lockIcon.indexOf(btnName) != -1)
      this.reportsAva = Object.assign([], tempList)
    }
    else {
      this.tableName= "All"
    }
  }

  getReportIndex(report: reportExe, reportList: reportExe[]): any {
    reportList.forEach((item, index) => {
      if (item.reportFilename == report.reportFilename && item.reportName == report.reportName && item.reportDescription == report.reportDescription) {
        reportList.splice(index, 1);
        return index;
      }
    })
  }

  changeReportAssoc(report: reportExe, index: number) {
    let reportAssociation: string = "";
    let value: boolean = false;
    if (report.lockIcon == "fas fa-plus" && report.lockClass == "btn btn-outline-success") { value = true; }
    this.hasChangedTrue.next(true);
    if (this.mode == 0 || this.mode.toString() == "editMode") {
      this.reportActiveChangeCount = this.reportActiveChangeCount + 1;
      if (report.lockIcon != "spinner-border spinner-border-sm") {
        report.lockIcon = "spinner-border spinner-border-sm"
        if (value) { reportAssociation = "add"; }
        let test = this.UserService.userReportAssociation({ "UserIDs": [this.user.companyUserID], "ACLTypeIDs": report.reportID }, String(this.company), reportAssociation)
          .subscribe(
            result => {

              if (value) {
                
                report.lockIcon = "fas fa-minus";
                report.lockClass = "btn btn-outline-danger";
                this.reportsOwned.push(report);
                this.aReports -= 1;
                this.vReports += 1;
              }
              else {
                this.getReportIndex(report, this.reportsOwned);
                report.lockIcon = "fas fa-plus"
                report.lockClass = "btn btn-outline-success";
                this.vReports -= 1;
                this.aReports += 1;
              }

              this.reportActiveChangeCount = this.reportActiveChangeCount - 1;
              if (this.reportActiveChangeCount == 0) {
                this.hasChangedFalse.next(false);
                test.unsubscribe();
              }

            },
            error => {

              console.log(error)
              this.reportActiveChangeCount = this.reportActiveChangeCount - 1;
              if (this.reportActiveChangeCount == 0) { this.hasChangedFalse.next(false); }
              if (value) {
                report.lockIcon = "fas fa-plus";
                report.lockClass = "btn btn-outline-success";
                this.vReports -= 1;
                this.aReports += 1;
              }
              else {
                report.lockIcon = "fas fa-minus"
                report.lockClass = "btn btn-outline-danger";
                this.aReports -= 1;
                this.vReports += 1;
              }
              test.unsubscribe();
            })
      }
    }
    else {
      if (report.lockIcon == "fas fa-plus") {
      
        report.lockIcon = "fas fa-minus"
        report.lockClass = "btn btn-outline-danger";
        this.reportsOwned.push(report)
        this.aReports -= 1;
        this.vReports += 1;
      }
      else {
        this.getReportIndex(report, this.reportsOwned);
        report.lockIcon = "fas fa-plus"
        report.lockClass = "btn btn-outline-success";
        this.vReports -= 1;
        this.aReports += 1;
      }

    }
  }

  returnReportForCloneUser() {
    return this.reportsOwned;
  }

  addAll() {
    if (this.search.trim().length == 0 && this.btnFilterSelected == 'all') {
      this.vReports = this.reportsAva.length;
      this.aReports = 0;
      this.reportsAva.forEach((item) => {
        item.lockClass = "btn btn-outline-danger";
        item.lockIcon = "fas fa-minus";
        this.reportsOwned.push(item)
      });
    }
    else if (this.search.trim().length == 0 && this.btnFilterSelected != 'all') {
      this.reportsAva.forEach(ra => {
        if (ra.lockIcon == "fas fa-plus") {
          ra.lockClass = "btn btn-outline-danger";
          ra.lockIcon = "fas fa-minus";
          this.reportsOwned.push(ra)
          this.vReports += 1;
          this.aReports -= 1;
        }
      })
    }
    else {
      this.reportsAva.forEach((item) => {
        if ((item.reportName.toLowerCase().indexOf(this.search.trim().toLowerCase()) > -1) ||
           (item.reportDescription.toLowerCase().indexOf(this.search.trim().toLowerCase()) > -1) ||
          (item.reportGroup.toString().toLowerCase().indexOf(this.search.trim().toLowerCase()) > -1)) {
          if (item.lockClass == "btn btn-outline-success" && item.lockIcon == "fas fa-plus") { 
            item.lockClass = "btn btn-outline-danger";
            item.lockIcon = "fas fa-minus";
            this.reportsOwned.push(item)
          this.vReports += 1;
          this.aReports -= 1;
}
        }
      });
 

    }
  }

  removeAll() {
    this.reportsOwned = [];
    if (this.search.trim().length == 0 && this.btnFilterSelected == 'all') {
      this.aReports = this.reportsAva.length;
      this.vReports = 0;
      this.reportsAva.forEach((item) => {
        item.lockClass = "btn btn-outline-success";
        item.lockIcon = "fas fa-plus";
        this.getReportIndex(item, this.reportsOwned);
      });
    }
    else if (this.search.trim().length == 0 && this.btnFilterSelected != 'all') {
      this.reportsAva.forEach(ra => {
        if (ra.lockIcon == "fas fa-minus") {
          ra.lockClass = "btn btn-outline-success";
          ra.lockIcon = "fas fa-plus";
          this.getReportIndex(ra, this.reportsOwned);
          this.aReports += 1;
          this.vReports -= 1;
        }
      })
    }
    else {
      this.reportsAva.forEach((item,index) => {
        if ((item.reportName.toLowerCase().indexOf(this.search.trim().toLowerCase()) > -1) ||
          (item.reportDescription.toLowerCase().indexOf(this.search.trim().toLowerCase()) > -1) ||
          (item.reportGroup.toString().toLowerCase().indexOf(this.search.trim().toLowerCase()) > -1)) {
          if (item.lockClass == "btn btn-outline-danger" && item.lockIcon == "fas fa-minus") { 
          item.lockClass = "btn btn-outline-success";
          item.lockIcon = "fas fa-plus";
          this.getReportIndex(item, this.reportsOwned);
          this.aReports += 1;
          this.vReports -= 1;
         }
        }
      });
   
    }
  }

}

interface report {
  reportName: string;
  reportGroupID: number[];
  reportGroup: string[];
  reportID: string[];
  reportFilename: string;
  reportDescription: string;
  reportDescPopup: string;
}

interface reportExe extends report {
  lockIcon: string;
  lockClass: string;
}

export enum state {
  cloneMode = 2,
  createMode = 1,
  editMode = 0
}
